import { render } from "./SupportPostPage.vue?vue&type=template&id=1a55f677&scoped=true"
import script from "./SupportPostPage.vue?vue&type=script&lang=js"
export * from "./SupportPostPage.vue?vue&type=script&lang=js"

import "./SupportPostPage.vue?vue&type=style&index=0&id=1a55f677&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a55f677"]])

export default __exports__